import { combinedSettingsSelector, TargetSelector } from "@client/selectors";

export const makeCountToOptionsSelector = () =>
  combinedSettingsSelector(TargetSelector.Entity, [
    { name: "countFrom", prop: "from" },
    { name: "countTo", prop: "to" },
    { name: "interval", prop: "refreshInterval", converter: (x) => parseInt(x) },
    { name: "speed", prop: "speed", converter: (x) => parseInt(x) }
  ]);
